






























































import { Component, Vue, Watch } from "vue-property-decorator";
import loader from "@/components/loader.vue";

import { momentTZ as moment } from "@/helpers/moment";
import accountsApi from "@/services/accounts";
import { debounce, cancel } from "typescript-debounce-decorator";
import { Action, Getter } from "vuex-class";

import { NSLog } from "@/helpers/log";
import { save, load } from "@/helpers/storage";
const log = NSLog("view/Home");

@Component({
  components: {
    loader
  }
})
export default class AccountFilter extends Vue {
  private loading = false;
  private events: any = [];
  private accountSearchStr = ""; // = load("account_search_string", null);
  private accounts: any = [];

  @Getter("globalSelectedAccount") private globalSelectedAccount: any;
  @Action("setGlobalSelectedAccount") private setGlobalSelectedAccount: any;
  @Getter("globalSelectedAccountDisplayText")
  private globalSelectedAccountDisplayText: any;

  public created() {
    if (this.globalSelectedAccount) {
      this.doSetSelectedAccount(this.globalSelectedAccount);
    }
  }

  private doSetSelectedAccount(acc: any) {
    this.setGlobalSelectedAccount(acc);
    this.$emit("input", acc ? [acc] : null);
  }

  private async searchAccounts(str?: string) {
    if (str === null) {
      this.accountSearchStr = "";
      this.doSetSelectedAccount(null);
    }
    this.accounts = [];
    if (!str || str.length < 3) {
      return;
    }
    this.loading = true;
    this.searchAccountsDebounce(str);
  }

  // debounced search account
  @debounce(500, { leading: false })
  private async searchAccountsDebounce(str: string) {
    this.doSetSelectedAccount(null);

    this.accountSearchStr = str;
    this.accounts = [];
    this.loading = true;
    try {
      this.accounts = await accountsApi.searchAccounts(str);
    } catch (e) {
      // this.setLastErr(e);
    }
    this.loading = false;
  }

  private destroyed() {
    cancel(this.searchAccounts);
  }

  limit(v: string) {
    if (`${v}`.length > 30)
      return `${v}`.substring(0, 30) + '...';
    return v;
  }
}
